import stopRepository from '@/repositories/bookings/stopRepository'
import apiState from '@/core/enums/apiStates'
import { Commit } from 'vuex'

const stopStore = {
  namespaced: true,
  state: {
    stopRoute: {},
    stopRouteState: apiState.INIT,
    detailsOpen: false,
    details: {},
    serviceFunctionsOpen: false,
    serviceFunctionType: null,
    pendingStop: null,
  },
  getters: {
    stopRouteState (state: any) {
      return state.stopRouteState
    },
    stopRoute (state: any) {
      return state.stopRoute
    },
    detailsOpen (state: any) {
      return state.detailsOpen
    },
    getDetails (state: any) {
      return state.details
    },
    serviceFunctionsOpen (state: any) {
      return state.serviceFunctionsOpen
    },
    serviceFunctionType (state: any) {
      return state.serviceFunctionType
    },
    pendingStop(state: any) { return state.pendingStop }
  },
  mutations: {
    setStopRouteState: (state: any, apiState: any) => {
      state.stopRouteState = apiState
    },
    setStopRoute: (state: any, response: any) => {
      console.log('setting stop route', response)
      const { data } = response
      state.stopRoute = data
      state.stopRouteState = apiState.LOADED
    },
    // #1260 - Without this, the previous booking's temperature status stays in the store while the
    // next one loads, and the start button gets evaluated against another trailer's readings.
    clearStopRoute: (state: any) => {
      state.stopRoute = {}
      state.stopRouteState = apiState.INIT
    },
    setDetails (state: any, details: any) {
      console.log('setting details to: ', details)
      state.details = details
      console.log('details state is: ', state.details)
    },
    toggleDetailsOpen (state: any) {
      state.detailsOpen = !state.detailsOpen
    },
    toggleServiceFunctions (state: any) {
      state.serviceFunctionsOpen = !state.serviceFunctionsOpen
    },
    setServiceFunctionType (state: any, type: string) {
      state.serviceFunctionType = type
    },
    setPendingStop(state: any, stop: any) { state.pendingStop = stop },
    clearPendingStop(state: any) { state.pendingStop = null },
  },
  actions: {
    async getStopRouteStatus ({ commit }: { commit: Commit }, dto: any) {
      commit('setStopRouteState', apiState.LOADING)
      try {
        const response = await stopRepository.getStopRouteStatus(dto.id, dto.toAddress)
        commit('setStopRoute', response)
        console.log('getStopRouteStatus', response)
      } catch (error) {
        commit('setStopRouteState', apiState.ERROR)
      }
    },
    async showStopDetails ({ commit }: { commit: Commit}, stopDetails: any) {
      console.log('setting stop to: ', stopDetails)
      commit('setDetails', stopDetails)
      commit('toggleDetailsOpen')
    },
    async toggleDetails ({ commit }: { commit: Commit}) {
      commit('toggleDetailsOpen')
    },
    async clearStopRoute ({ commit }: { commit: Commit }) {
      commit('clearStopRoute')
    },
    async setPendingStop({ commit }: { commit: Commit }, stop: any) {
      commit('setPendingStop', stop)
    },
    async clearPendingStop({ commit }: { commit: Commit }) {
      commit('clearPendingStop')
    },
  },
  modules: {
  }
}

export default stopStore
